module.exports = __webpack_public_path__ + "static/media/nps_image.09997ecc.png";